import React, { Component } from 'react'

import JoinAccountForm from 'features/Auth/JoinAccountForm'
import LoginForm from 'features/Auth/LoginForm'
import Button from 'components/Button'
import OrDivider from 'components/OrDivider'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'

export default class LoginOrRegister extends Component {
  state = {
    formType: 'welcome', // welcome || signIn || signUp
  }
  setFormType = formType =>
    this.setState({
      formType,
    })
  render() {
    const { afterSubmit, onBack } = this.props
    const { formType } = this.state
    if (formType === 'welcome') {
      return (
        <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}>
          <Button ghost color="tertiary" onClick={() => this.setFormType('signIn')}>
            Sign in
          </Button>
          <OrDivider />
          <Button color="tertiary" onClick={() => this.setFormType('signUp')}>
            Sign up
          </Button>

          {onBack && (
            <>
              <br />
              <br />
              <Button plain onClick={onBack}>
                Back
              </Button>
            </>
          )}
        </div>
      )
    } else if (formType === 'signIn') {
      return <LoginForm prev={() => this.setFormType('welcome')} afterSubmit={afterSubmit} />
    } else if (formType === 'signUp') {
      return <JoinAccountForm prev={() => this.setFormType('welcome')} afterSubmit={afterSubmit} />
    }
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/LoginOrRegister/LoginOrRegister.jsx